function initScrollReveal() {
  var selector = [
    "#Frame2 .reveal",
    "#Frame2 .reveal-stagger",
    "#Frame3 .reveal",
    "#Frame3 .reveal-stagger",
    "#Frame4 .reveal",
    "#Frame4 .reveal-stagger",
    "#Frame5 .reveal",
    "#Frame5 .reveal-stagger",
    "#Frame6 .reveal",
    "#Frame6 .reveal-stagger",
    "#Frame7 .reveal",
    "#Frame7 .reveal-stagger",
    "#Frame8 .reveal",
    "#Frame8 .reveal-stagger",
  ].join(",");
  var targets = document.querySelectorAll(selector);
  if (!targets.length) return;

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReduced || typeof IntersectionObserver === "undefined") {
    targets.forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px 0px 0px" },
  );

  targets.forEach(function (el) {
    if (el.isConnected) observer.observe(el);
  });
}

window.addEventListener("load", initScrollReveal);
